export const API_CONFIG = {
  // baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  // wsURL: process.env.REACT_APP_WS_URL || 'ws://localhost:5001',

  //  baseURL: process.env.REACT_APP_API_URL || 'http://43.205.213.80:5001/api',
  //  wsURL: process.env.REACT_APP_WS_URL || 'ws://43.205.213.80:5001',

  //Connection 1. // S3 - autotrade-app
   baseURL: process.env.REACT_APP_API_URL || 'https://api.tradingmyappdev.net.in/api',
   wsURL: process.env.REACT_APP_WS_URL || 'wss://api.tradingmyappdev.net.in',

  //. Connection 2 // S3 - autotrade-app-2
  //  baseURL: process.env.REACT_APP_API_URL || 'https://api-new.tradingmyappdev.net.in/api',
  //  wsURL: process.env.REACT_APP_WS_URL || 'wss://api-new.tradingmyappdev.net.in',


  timeout: 30000,
  getAuthHeaders: () => {
    const token = localStorage.getItem('token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }
};

export const ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register'
  },

  // Symbols
  SYMBOLS: {
    SEARCH: '/symbols/search'
  },

  // TrueData
  TRUEDATA: {
    BASE: '/truedata',
    CONNECT: '/truedata/connect',
    DISCONNECT: '/truedata/disconnect',
    STATUS: '/truedata/status',
    SUBSCRIBE: '/truedata/subscribe',
    UNSUBSCRIBE: '/truedata/unsubscribe',
    MARKET_STATUS: '/truedata/market-status',
    LTP: '/truedata/ltp',
    HISTORY_BARS: '/truedata/history/bars',
    HISTORY_LAST_BARS: '/truedata/history/last-bars',
    SEARCH: '/truedata/search',
    OPTION_CHAIN: '/truedata/option-chain'
  },

  // Market Data
  MARKET_DATA: {
    GET: '/market-data',
    SEARCH: '/market-data/search',
    SUBSCRIBE: '/market-data/subscribe',
    UNSUBSCRIBE: '/market-data/unsubscribe',
    STATUS: '/market-data/status'
  },

  // Portfolio
  PORTFOLIO: {
    DASHBOARD: '/portfolio/dashboard',
    GET: '/portfolio'
  },

  // Configuration — NSE
  CONFIG: {
    GET: '/config',
    CREATE: '/config',
    UPDATE: '/config',
    DELETE: '/config'
  },

  // Configuration — BSE
  BSE_CONFIG: {
    GET: '/bse/config',
    CREATE: '/bse/config',
    UPDATE: '/bse/config',
    DELETE: '/bse/config'
  },

  // Orders — BSE
  BSE_ORDERS: {
    GET: '/bse/orders',
    OPEN: '/bse/orders/open',
    EXIT_ALL: '/bse/orders/exit-all',
    CLEAR: '/bse/orders/clear',
    DELETE: '/bse/orders/delete-permanently'
  },

  // Live Data
  LIVE_DATA: {
    SYMBOLS: '/live-data/symbols',
    LIVE: '/live-data/live'
  }
};